import type {ReactElement} from 'react';
import React from 'react';
import {Panel, PanelHeader} from '@Components/panel';
import useDefaultPanelClose from '@Panels/hooks/useDefaultPanelClose';
import {ContextualMenu} from '@Components/contextual-menu';
import {RectangleRoundnessOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/rectangle-roundness-option/rectangle-roundness-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';

interface PosterEditorRectangleRoundingPanelProps {
  panelId: string;
}
export default function PosterEditorRectangleRoundingPanel({...props}: PosterEditorRectangleRoundingPanelProps): ReactElement<any> | null {
  const onClose = useDefaultPanelClose(props.panelId);
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;

  if (!activeItem || (activeItem && !activeItem.isRectangle())) {
    return null;
  }

  const getContent = (): ReactElement<any> => {
    return (
      <ContextualMenu id="rectangle-roundness-mobile-panel" hasMobileModalPadding hasMobileMorphingProperties>
        <RectangleRoundnessOption />
      </ContextualMenu>
    );
  };

  const getHeader = (): ReactElement<any> => {
    return <PanelHeader onClose={onClose} title={window.i18next.t('pmwjs_roundness')} />;
  };
  return <Panel panelHeader={getHeader()} panelContent={getContent()} />;
}
